import { render, staticRenderFns } from "./ContractorFormV2.vue?vue&type=template&id=72daef98&scoped=true&"
import script from "./ContractorFormV2.vue?vue&type=script&lang=ts&"
export * from "./ContractorFormV2.vue?vue&type=script&lang=ts&"
import style0 from "./ContractorFormV2.vue?vue&type=style&index=0&id=72daef98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72daef98",
  null
  
)

export default component.exports